/* eslint-disable import/no-anonymous-default-export */
import axiosInstance from "../axios/axios-configuration";
import { CancelToken } from "axios";
import { IFolderPecMail, ISendMailRequest, IPagedMailsResponse, IPagedMailsRequest, IStatoRicevutaPecMail } from "../shared/interfaces";




const getMailboxContacts = (aooId: number, uorId: number, mailbox: string, cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.get(`PecMail/${aooId}/${uorId}/GetMailboxContacts`, { cancelToken: cancelToken, params: { mailbox: mailbox } })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const getAllFolders = (aooId: string, uorId: number, mailbox: string, cancelToken?: CancelToken): Promise<IFolderPecMail[]> => {
    return axiosInstance.get(`PecMail/${aooId}/${uorId}/GetAllFolders`, { cancelToken: cancelToken, params: { mailbox: mailbox } })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const getNotRegisteredMailsInFolderAsStream = (aooId: string, uorId: number, mailbox: string, pagedMailsRequest: IPagedMailsRequest, cancelToken?: CancelToken): Promise<IPagedMailsResponse> => {
    return axiosInstance.post(`PecMail/${aooId}/${uorId}/GetNotRegisteredMailsInFolderAsStream`, pagedMailsRequest, { cancelToken: cancelToken, params: { mailbox: mailbox } })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const getMailById = (aooId: string, uorId: number, mailbox: string, mailId: string, pdf: boolean, cancelToken?: CancelToken): Promise<any> => {
    let myParams = {
        mailbox,
        mailId,
        pdf
    };
    return axiosInstance.get(`PecMail/${aooId}/${uorId}/GetMailById`, { cancelToken: cancelToken, params: myParams })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const getBase64ForMailAttachment = (aooId: number, uorId: number | undefined, mailbox: string, mailId: number, attachmentId: number, cancelToken?: CancelToken): Promise<any> => {
    let myParams = {
        mailbox,
        mailId,
        attachmentId,
        uorId
    };
    return axiosInstance.get(`PecMail/${aooId}/GetBase64ForMailAttachment`, { cancelToken: cancelToken, params: myParams })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const getBase64ForReceipt = (aooId: number, uorId: number | undefined, mailbox: string, mailId: number, receiptId: number, cancelToken?: CancelToken): Promise<any> => {
    let myParams = {
        mailbox,
        mailId,
        receiptId,
        uorId 
    };
    return axiosInstance.get(`PecMail/${aooId}/GetBase64ForReceipt`, { cancelToken: cancelToken, params: myParams })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const setMailAsRegistered = (aooId: number, uorId: number, mailbox: string, idMail: number, cancelToken?: CancelToken): Promise<any> => {
    let myParams = {
        mailbox,
        idMail
    };
    return axiosInstance.get(`PecMail/${aooId}/${uorId}/SetMailAsRegistered`, { cancelToken: cancelToken, params: myParams })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const sendMail = (aooId: number, uorId: number, mailbox: string, sendMailRequest: ISendMailRequest, cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.post(`PecMail/${aooId}/${uorId}/SendMail`, sendMailRequest, { cancelToken: cancelToken, params: { mailbox: mailbox } })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const getStatiRicevuteByMailId = (aooId: number, uorId: number | undefined, mailbox: string, pecMailId: number, cancelToken?: CancelToken): Promise<IStatoRicevutaPecMail[]> => {
    let myParams = {
        mailbox,
        pecMailId,
        uorId
    };
    return axiosInstance.get(`PecMail/${aooId}/GetStatiRicevuteByMailId`, { cancelToken: cancelToken, params: myParams })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}


export default {
    getMailboxContacts,
    getAllFolders,
    getNotRegisteredMailsInFolderAsStream,
    getMailById,
    getBase64ForMailAttachment,
    getBase64ForReceipt,
    setMailAsRegistered,
    sendMail,
    getStatiRicevuteByMailId
}